export default "__VITE_ASSET__twAZqhh4__"